import _ from 'lodash';
import IApplicationState from 'app/types/state';
import { parseAmount, toTitleCase } from 'app/utils/parsers';

function mapSelect(organisationAddresses, n) {
  const sa = organisationAddresses.organisationAddressesById[n];
  if (sa) {
    return { id: sa.id, name: sa.name };
  }
  return null;
}

export function getOrganisationAddressesByIdInSelectFormat(organisationAddresses): any {
  return _.map(organisationAddresses.organisationAddressIds, (n) => mapSelect(organisationAddresses, n));
}

export function getCurrentOrganisationAddress(state: IApplicationState): any {
  if (
    state.organisationAddresses.organisationAddressesById !== undefined
    && state.organisationAddresses.currentOrganisationAddressId !== undefined
  ) {
    const findOrganisationAddress = state.organisationAddresses.organisationAddressesById[
      state.organisationAddresses.currentOrganisationAddressId
    ];
    const currentOrganisationAddress = {
      ...findOrganisationAddress,
    };

    return currentOrganisationAddress;
  }
  return {};
}

export function getCurrentFormOrganisationAddress(state: IApplicationState) {
  return {
    ...getCurrentOrganisationAddress(state),
    ...state.organisationAddresses.requestedData,
  };
}

export function getOrganisationAddresses(state: IApplicationState): any {
  return {
    ...state.organisationAddresses,
    currentOrganisationAddress: {
      ...getCurrentOrganisationAddress(state),
    },
    currentFormOrganisationAddress: {
      ...getCurrentFormOrganisationAddress(state),
    },
  };
}

export function getOrganisationAddressesByTeamId(state, teamId): any {
  if (
    state.organisationAddresses.organisationAddressesById !== undefined
    && teamId != null
  ) {
    return _.filter(state.organisationAddresses.organisationAddressesById, { teamId });
  }
  return {};
}

export function getOrganisationAddressesByIds(organisationAddressesById, tagIds): any {
  if (organisationAddressesById !== undefined && tagIds != null) {
    return _.pick(organisationAddressesById, tagIds);
  }
  return {};
}

export function getOrganisationAddressIdsByTeamId(state, teamId): any {
  if (
    state.organisationAddresses.organisationAddressesById !== undefined
    && teamId != null
  ) {
    const filtered = _.filter(state.organisationAddresses.organisationAddressesById, {
      teamId,
    });
    if (filtered != null) {
      return _.map(filtered, 'id');
    }
    return [];
  }
  return [];
}

function parseOrganisationAddressTypeText(feeType) {
  let parsedText = '';
  if (feeType === 'event') {
    parsedText = 'Match Fee';
  }
  if (feeType === 'walkover') {
    parsedText = 'Forfeit Fee';
  }
  if (feeType === 'event-variable') {
    parsedText = 'Match Variable Fee';
  }
  return parsedText;
}

function parseOrganisationAddressTypeColour(feeType) {
  let parsedColour = 'grey';
  if (feeType === 'event') {
    parsedColour = 'purple';
  }
  if (feeType === 'walkover') {
    parsedColour = 'red';
  }
  if (feeType === 'event-variable') {
    parsedColour = 'purple';
  }
  return parsedColour;
}

function parseOrganisationAddressType(status) {
  const statuses = [];
  const colour = parseOrganisationAddressTypeColour(status);
  const text = parseOrganisationAddressTypeText(status);

  statuses.push({ colour, text });

  return statuses;
}

function parseOrganisationAddressTimeframe(timeframe) {
  if (_.isNull(timeframe)) {
    return null;
  }

  return `< ${timeframe.toString()} hrs`;
}

export function getOrganisationAddressSummary(organisationAddress): any {
  const organisationAddressSummary = {
    id: organisationAddress.id,
    feeType: parseOrganisationAddressType(organisationAddress.feeType),
    name: organisationAddress.name,
    amount: parseAmount(organisationAddress.amount),
    timeframe: parseOrganisationAddressTimeframe(organisationAddress.timeframe),
  };
  return organisationAddressSummary;
}
